import { RaceNew } from './raceNew';

const raceNewMapper = new RaceNew();

export { raceNewMapper };
export * from './racerToState';
export * from './mapToConfirmBody';
export * from './mapToFormAttachToProfile';
